import { useTheme } from '@emotion/react';
import { Typography } from '@mui/material';
import { formatMoneyAmount } from 'framework/base/components/AryNumberFormatter';
import useSystemRate from 'framework/base/hooks/useSystemRate';
import React from 'react';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';

const SystemRate = ({
  baseCurrencyCode,
  destinationCurrencyCode,
  initialAmount
}) => {
  const theme = useTheme();
  const { t } = useFrameworkTranslation();
  const { systemRate } = useSystemRate({
    baseCurrencyCode,
    destinationCurrencyCode,
    initialAmount
  });

  return (
    <Typography variant="c2Bold" color={theme.text.tertiary.color}>
      {t('System Rate')}:{' '}
      {systemRate === null
        ? '-'
        : formatMoneyAmount(
            systemRate < 1 ? 1 / systemRate : systemRate,
            2,
            true
          )}
    </Typography>
  );
};

export default SystemRate;
